import type { TestId } from '@repo/test-id';

interface Props {
  title: string;
  subtitle: string;
  testId: TestId;
}

export default function Header({ title, subtitle, testId }: Props) {
  return (
    <div className="flex flex-col gap-1" data-testid={testId}>
      <h1 className="text-heading text-2xl leading-8 font-semibold" data-testid={testId.append('title')}>
        {title}
      </h1>
      <p className="text-body font-normal" data-testid={testId.append('subtitle')}>
        {subtitle}
      </p>
    </div>
  );
}
